"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightsClientExtended = void 0;
const insights_client_library_1 = require("@eccr-cuttingedge/insights-client-library");
const Initable_1 = require("../base/Initable");
/**
 * Extended InsightsClient, using "Composition over Inheritance" principle
 */
class InsightsClientExtended {
    constructor(client) {
        this.client = client;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.client.InitializeInsightsClient();
        });
    }
    queueQuery(query, filter) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.client.GetInsightsRule(query, filter));
        });
    }
    submitInsight(insight) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.SubmitInsight(insight);
        });
    }
    getInsightRules(filter) {
        return this.queueQuery(insights_client_library_1.getInsightRules, filter);
    }
    getInsightRulesEngines(filter) {
        return this.queueQuery(insights_client_library_1.getInsightRulesEngines, filter);
    }
    getInsight(filter) {
        return this.queueQuery(insights_client_library_1.insight, filter);
    }
    getInsights(filter) {
        return this.queueQuery(insights_client_library_1.insights, filter);
    }
}
__decorate([
    Initable_1.RequireInit
], InsightsClientExtended.prototype, "queueQuery", null);
__decorate([
    Initable_1.RequireInit
], InsightsClientExtended.prototype, "submitInsight", null);
exports.InsightsClientExtended = InsightsClientExtended;
